import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/theme-global.css";
import App from "@/App";
import GlobalRequestLoader from "./components/GlobalRequestLoader";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <GlobalRequestLoader><App /></GlobalRequestLoader>
    </QueryClientProvider>
  </React.StrictMode>,
);
